import { RunParameterModel } from "@app/api2/api";

export const isParameterDisabled = (p: RunParameterModel) => {

    if (!p.userEditable) {
        return true;
    }

    return false;
}

/**
 * Determines if a parameter row should be visible based on the showIfChecked string.
 * showIfChecked format: comma-separated list of field names, optionally prefixed with '!' for negation,
 * or with '=' for equality checks (e.g. "foo,!bar,baz=2").
 */
export const isParameterVisible = (p: RunParameterModel, values) => {
    if (!p.userVisible) {
        return false;
    }

    if (!p.showIfChecked) {
        return true;
    }

    return evaluateShowIfChecked(p, values);
}

export const evaluateShowIfChecked = (p: RunParameterModel, values: any) => {
    const { equalFields, negatedFields, trueFields } = parseShowIfChecked(p.showIfChecked);

    return negatedFields.reduce((show, field) => show && !(values[field] === "1"), true)
        && trueFields.reduce((show, field) => show && (values[field] === "1"), true)
        && equalFields.reduce((show, field) => show && (values[field[0]] == field[1]), true);
}


/**
 * Helper to parse showIfChecked string into trueFields, falseFields, and equalFields.
 * @param showIfChecked string
 * showIfChecked format: comma-separated list of field names, optionally prefixed with '!' for negation,
 * or with '=' for equality checks (e.g. "foo,!bar,baz=2").
 */
export const parseShowIfChecked = (showIfChecked: string) => {
    const fields = showIfChecked.split(',');

    const equalFields = fields.filter(x => x.indexOf('=') > -1).map(x => x.split('='));
    const negatedFields = fields.filter(f => f.startsWith("!") && f.indexOf('=') == -1).map(m => m.slice(1));
    const trueFields = fields.filter(f => !f.startsWith("!") && f.indexOf('=') == -1);

    return { equalFields, negatedFields, trueFields };
}


